<micro-select-combo #sel
              placeholder="File2Sms Job Status"
              [mode]="mode"
              [(id)]="status"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
